export default __webpack_public_path__ + "static/media/Full Belly Graphic White.bded7c53.png";